let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("e6JD1")).then(() => parcelRequire('lpVqo'));